import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import NeuralCanvas from "../components/aura/NeuralCanvas";
import CustomCursor from "../components/aura/CustomCursor";
import Nav from "../components/aura/Nav";
import Hero from "../components/aura/Hero";
import ProblemSection from "../components/aura/ProblemSection";
import MemorySystem from "../components/aura/MemorySystem";
import VoiceTutoring from "../components/aura/VoiceTutoring";
import LearnerGraph from "../components/aura/LearnerGraph";
import HowItWorks from "../components/aura/HowItWorks";
import MemoryDemo from "../components/aura/MemoryDemo";
import Comparison from "../components/aura/Comparison";
import PricingWaitlist from "../components/aura/PricingWaitlist";
import FinalCTA from "../components/aura/FinalCTA";
import Footer from "../components/aura/Footer";

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data }) => {
      if (data.session) {
        const { data: profile } = await supabase
          .from("users")
          .select("display_name")
          .eq("id", data.session.user.id)
          .maybeSingle();

        if (profile?.display_name) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/onboarding", { replace: true });
        }
      }
    });
  }, [navigate]);

  return (
    <div className="relative min-h-screen bg-base text-ink overflow-x-clip" data-testid="aura-landing">
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-grid-faint opacity-60" style={{ backgroundSize: "48px 48px" }} />
      <NeuralCanvas />
      <div aria-hidden className="pointer-events-none fixed inset-0 z-[1]" style={{ background: "linear-gradient(180deg, var(--hero-veil) 0%, transparent 28%, transparent 72%, rgb(var(--bg-rgb) / 0.82) 100%)" }} />

      <CustomCursor />

      <div className="relative z-10">
        <Nav />
        <main>
          <Hero />
          <Divider />
          <ProblemSection />
          <Divider />
          <MemorySystem />
          <Divider />
          <VoiceTutoring />
          <Divider />
          <LearnerGraph />
          <Divider />
          <HowItWorks />
          <Divider />
          <MemoryDemo />
          <Divider />
          <Comparison />
          <Divider />
          <PricingWaitlist />
          <Divider />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </div>
  );
};

const Divider = () => (
  <div aria-hidden className="max-w-7xl mx-auto px-6">
    <div className="divider-hair" />
  </div>
);

export default Landing;
